export default {
  createDrawing: 'create drawing',
  editDrawing: 'edit drawing',
  whetherDelete: 'whether delete',
  pleaseEnterTheRemark: 'please enter the remark',
  pleaseEnterTheSeqNo: 'please enter the seqNo',
  deleteDrawing: 'this action will permanently delete the drawing',
  whetherContinue: 'continue',
  deleteSuccess: 'delete success',
  cancelDelete: 'deletion cancelled',
  resultError: 'return error result',
  pleaseEnterCorrectCode: 'please enter the correct code',
}
